module.exports = "pegasus_template/assets/themelp1/large/61.png";